import { useEffect, useState } from 'react';

export type NetworkClass = 'fast' | 'slow' | 'unknown';

interface NavigatorWithConnection extends Navigator {
  connection?: {
    effectiveType?: '2g' | '3g' | '4g' | 'slow-2g' | string;
    saveData?: boolean;
    addEventListener?: (event: string, handler: () => void) => void;
    removeEventListener?: (event: string, handler: () => void) => void;
  };
}

function compute(): NetworkClass {
  const conn = (navigator as NavigatorWithConnection).connection;
  if (!conn) return 'unknown';
  if (conn.saveData) return 'slow';
  switch (conn.effectiveType) {
    case 'slow-2g':
    case '2g':
    case '3g':
      return 'slow';
    default:
      return 'fast';
  }
}

export function useNetworkClass(): NetworkClass {
  const [cls, setCls] = useState<NetworkClass>(() => compute());

  useEffect(() => {
    const conn = (navigator as NavigatorWithConnection).connection;
    if (!conn?.addEventListener) return;
    const handler = () => setCls(compute());
    conn.addEventListener('change', handler);
    return () => conn.removeEventListener?.('change', handler);
  }, []);

  return cls;
}
